import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import actions2 from '../offers/actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove, createaARticles } from '../../services/offerArticle'
import { find as find2 } from '../../services/offer'

function* fetchOfferArticlesRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchOfferArticles'))
  if (fe == null) {
    fe.size = 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_OFFERARTICLE,
    result,
  })
}

function* fetchOfferArticles({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchOfferArticles'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchOfferArticles', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_OFFERARTICLE,
    result,
  })
}

function* fetchOfferArticleEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_OFFERARTICLE,
    result,
  })
}

function* fetchOfferArticleSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_OFFERARTICLE_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_OFFERARTICLES,
  })
}

function* fetchOfferArticleDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_OFFERARTICLE_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_OFFERARTICLES,
  })
}

function* fetchOfferArticles2({id}) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(createaARticles, id)
  yield put({
    type: actions.NEW_OFFERARTICLE2_RECIEVED,
    result,
  });
  yield put({
    type: actions.RE_FETCH_OFFERARTICLES,
  })
  const result2 = yield call(find2, id)
  yield put({
    type: actions2.EDIT_OFFER,
    result: result2,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_OFFERARTICLES, fetchOfferArticles),
    takeEvery(actions.NEW_OFFERARTICLE2, fetchOfferArticles2),
    takeEvery(actions.FETCH_OFFERARTICLE, fetchOfferArticleEdit),
    takeEvery(actions.SAVE_OFFERARTICLE, fetchOfferArticleSave),
    takeEvery(actions.DELETE_OFFERARTICLE, fetchOfferArticleDelete),
    takeEvery(actions.RE_FETCH_OFFERARTICLES, fetchOfferArticlesRefresh),
  ])
}
